import { render, staticRenderFns } from "./ViewBlock.vue?vue&type=template&id=3c43e60e"
import script from "./ViewBlock.vue?vue&type=script&lang=js"
export * from "./ViewBlock.vue?vue&type=script&lang=js"
import style0 from "./ViewBlock.vue?vue&type=style&index=0&id=3c43e60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports